export default __webpack_public_path__ + "static/media/sv22_en_rudl_a2.30128cac.mp3";